import { cn as e } from "../../cn.js";
import { getStyles as t } from "./style.js";
import { FormChevronIcon as n, FormClearButton as r, FormErrorText as i, FormHelperText as a, FormLabel as o } from "../shared/form-primitives.js";
import s from "react";
import { Check as ee, Search as te } from "lucide-react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import { Portal as d } from "@ark-ui/react/portal";
import { When as f } from "react-if";
import { Field as p } from "@ark-ui/react/field";
import { Highlight as ne } from "@ark-ui/react/highlight";
import { useFilter as re } from "@ark-ui/react/locale";
import { Select as m, createListCollection as h } from "@ark-ui/react/select";
// src/design/forms/select/index.tsx
var g = 8, _ = ({ label: _, "aria-label": v, hideLabel: y, placeholder: b = "Select an option...", helperText: x, errorText: S, required: w, invalid: ie, disabled: T, options: E, value: D, defaultValue: O, onChange: k, onOpenChange: A, onFocus: ae, onBlur: j, multiple: M, name: oe, form: se, multiValueVariant: ce = "default", showClearButton: N = !0, searchable: le, rootClassName: ue, className: de }) => {
	let P = t(), F = ie || !!S, I = `${s.useId()}trigger`, L = s.useMemo(() => C(O, E), [O, E]), [R, z] = s.useState(null), [B, V] = s.useState(!1), fe = s.useMemo(() => C(D, E), [D, E]), H = D === void 0 ? B ? R : L : fe, U = le ?? E.length > g, { contains: pe } = re({ sensitivity: "base" }), [W, G] = s.useState(""), [K, me] = s.useState(null), he = s.useMemo(() => H ? (Array.isArray(H) ? H : [H]).map((e) => String(e.value)) : [], [H]), ge = s.useMemo(() => L ? (Array.isArray(L) ? L : [L]).map((e) => String(e.value)) : [], [L]), q = H ? Array.isArray(H) ? H : [H] : [], J = U && W ? E.filter((e) => pe(e.label, W)) : E, Y = h({
		items: J,
		itemToString: (e) => e.label,
		itemToValue: (e) => String(e.value)
	}), X = J.some((e) => String(e.value) === K) ? K : J[0] ? String(J[0].value) : null, Z = s.useRef(null);
	s.useEffect(() => {
		X && Z.current?.querySelector("[data-highlighted]")?.scrollIntoView({ block: "nearest" });
	}, [X]);
	let Q = H && (!Array.isArray(H) || H.length > 0) || !1, $ = N && Q && !T;
	return /* @__PURE__ */ u(p.Root, {
		className: e(P.root({ disabled: T }), ue),
		invalid: F,
		required: w,
		disabled: T,
		children: [
			/* @__PURE__ */ u(m.Root, {
				lazyMount: !0,
				unmountOnExit: !0,
				collection: Y,
				value: he,
				defaultValue: ge,
				onValueChange: (e) => {
					let t = e.value.map((e) => E.find((t) => String(t.value) === e) ?? q.find((t) => String(t.value) === e)).filter((e) => e !== void 0), n = M ? t : t[0] || null;
					z(n), V(!0), k?.({
						value: n,
						selectedOptions: n
					});
				},
				onOpenChange: (e) => {
					e.open || G(""), A?.(e);
				},
				highlightedValue: X,
				onHighlightChange: (e) => me(e.highlightedValue),
				multiple: M,
				name: oe,
				form: se,
				disabled: T,
				invalid: F,
				required: w,
				ids: { trigger: I },
				className: "flex flex-col gap-1",
				children: [
					_ && /* @__PURE__ */ l(m.Label, {
						asChild: !0,
						children: /* @__PURE__ */ l(o, {
							required: w,
							disabled: T,
							htmlFor: I,
							className: y ? "sr-only" : void 0,
							children: _
						})
					}),
					/* @__PURE__ */ u(m.Control, {
						className: P.control({ disabled: T }),
						children: [/* @__PURE__ */ u(m.Trigger, {
							className: e(P.trigger({ invalid: F }), de),
							"aria-label": v,
							onFocus: ae,
							onBlur: j,
							children: [M && q.length > 0 ? /* @__PURE__ */ l("div", {
								className: P.valueContainer(),
								children: q.map((e) => /* @__PURE__ */ u("div", {
									className: P.multiValue({ variant: ce }),
									children: [/* @__PURE__ */ l("span", {
										className: P.multiValueLabel(),
										children: e.label
									}), /* @__PURE__ */ l(r, {
										as: "span",
										size: "sm",
										iconSize: 12,
										"aria-label": `Remove ${e.label}`,
										onClick: (t) => {
											if (t.stopPropagation(), !k || !M || !H || !Array.isArray(H)) return;
											let n = H.filter((t) => t.value !== e.value);
											k?.({
												value: n,
												selectedOptions: n
											});
										},
										disabled: T
									})]
								}, e.value))
							}) : !M && q[0] ? /* @__PURE__ */ l("span", {
								className: e(P.valueText({ hasValue: Q })),
								children: q[0].label
							}) : /* @__PURE__ */ l(m.ValueText, {
								placeholder: b,
								className: e(P.valueText({ hasValue: Q }))
							}), /* @__PURE__ */ l("div", {
								className: "flex items-center gap-1 shrink-0 ml-2",
								children: Q && N ? $ ? /* @__PURE__ */ l("span", {
									"aria-hidden": "true",
									className: "block w-5 h-5"
								}) : null : /* @__PURE__ */ l(m.Indicator, {
									className: P.indicator(),
									children: /* @__PURE__ */ l(n, {
										size: "md",
										disabled: T
									})
								})
							})]
						}), $ && /* @__PURE__ */ l(m.ClearTrigger, {
							asChild: !0,
							children: /* @__PURE__ */ l(r, {
								size: "md",
								iconSize: 16,
								className: "absolute right-2 top-1/2 -translate-y-1/2"
							})
						})]
					}),
					/* @__PURE__ */ l(d, { children: /* @__PURE__ */ l(m.Positioner, {
						className: P.positioner(),
						children: /* @__PURE__ */ u(m.Content, {
							className: P.content(),
							children: [U && /* @__PURE__ */ u("div", {
								className: P.searchWrapper(),
								children: [/* @__PURE__ */ l("span", {
									className: P.searchIconWrapper(),
									children: /* @__PURE__ */ l(te, { size: 14 })
								}), /* @__PURE__ */ l("input", {
									autoFocus: !0,
									type: "text",
									value: W,
									onChange: (e) => G(e.target.value),
									onKeyDown: (e) => {
										e.key === " " && e.stopPropagation();
									},
									placeholder: "Search...",
									className: P.searchInput()
								})]
							}), /* @__PURE__ */ l(m.List, {
								ref: Z,
								className: P.list(),
								children: Y.items.length === 0 ? /* @__PURE__ */ l("div", {
									className: P.emptyState(),
									children: W ? `No results for "${W}"` : "No options"
								}) : Y.items.map((e) => /* @__PURE__ */ u(m.Item, {
									item: e,
									className: P.item(),
									children: [/* @__PURE__ */ l(m.ItemText, {
										className: P.itemText(),
										children: U && W ? /* @__PURE__ */ l(ne, {
											text: e.label,
											query: W,
											ignoreCase: !0,
											matchAll: !0
										}) : e.label
									}), /* @__PURE__ */ l(m.ItemIndicator, {
										className: P.itemIndicator(),
										children: /* @__PURE__ */ l(ee, { size: 16 })
									})]
								}, e.value))
							})]
						})
					}) }),
					/* @__PURE__ */ l(m.HiddenSelect, { "aria-labelledby": null })
				]
			}),
			/* @__PURE__ */ l(f, {
				condition: !(!x || S),
				children: /* @__PURE__ */ l(a, { children: /* @__PURE__ */ l(c, { children: x }) })
			}),
			/* @__PURE__ */ l(f, {
				condition: !!S,
				children: /* @__PURE__ */ l(i, { children: /* @__PURE__ */ l(c, { children: S }) })
			})
		]
	});
}, v = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ l(p.Root, {
		className: e(a.root({ disabled: i.disabled }), r),
		...i,
		children: n
	});
}, y = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ l(p.Label, {
		className: e(a.label(), r),
		...i,
		children: n
	});
}, b = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ l(p.HelperText, {
		className: e(a.helperText(), r),
		...i,
		children: n
	});
}, x = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ l(p.ErrorText, {
		className: e(a.errorText(), r),
		...i,
		children: n
	});
}, S = ({ children: n, className: r, ...i }) => {
	let a = t();
	return /* @__PURE__ */ l(p.RequiredIndicator, {
		className: e(a.requiredIndicator(), r),
		...i,
		children: n ?? "*"
	});
};
function C(e, t) {
	if (e === void 0) return;
	if (e === null) return null;
	let n = (e) => t.find((t) => String(t.value) === String(e)), r = (e) => typeof e == "object" ? e : n(e) ?? {
		label: String(e),
		value: e
	};
	return Array.isArray(e) ? e.map(r) : e === "" && !n("") ? null : r(e);
}
var w = Object.assign(_, {
	Default: _,
	Root: v,
	Label: y,
	HelperText: b,
	ErrorText: x,
	RequiredIndicator: S,
	getStyles: t,
	SelectRoot: m.Root,
	SelectLabel: m.Label,
	SelectControl: m.Control,
	SelectTrigger: m.Trigger,
	SelectValueText: m.ValueText,
	SelectIndicator: m.Indicator,
	SelectClearTrigger: m.ClearTrigger,
	SelectPositioner: m.Positioner,
	SelectContent: m.Content,
	SelectList: m.List,
	SelectItem: m.Item,
	SelectItemText: m.ItemText,
	SelectItemIndicator: m.ItemIndicator,
	SelectItemGroup: m.ItemGroup,
	SelectItemGroupLabel: m.ItemGroupLabel,
	SelectHiddenSelect: m.HiddenSelect
});
export { w as Select, h as createListCollection };

//# sourceMappingURL=index.js.map